import { NavigationAlignments } from './types';
export var getShouldRenderTitleBelow = function getShouldRenderTitleBelow(_ref) {
  var shouldRenderTitleOnNewLine = _ref.shouldRenderTitleOnNewLine,
      navigationAlignment = _ref.navigationAlignment,
      hasSmallTitle = _ref.hasSmallTitle;

  if (shouldRenderTitleOnNewLine !== undefined) {
    return !!shouldRenderTitleOnNewLine;
  }

  if (navigationAlignment === NavigationAlignments.Trailing) {
    return false;
  }

  return !hasSmallTitle;
};
export var getShouldRenderActionContainers = function getShouldRenderActionContainers(_ref2) {
  var hasBackButton = _ref2.hasBackButton,
      hasNavigationItem = _ref2.hasNavigationItem,
      navigationAlignment = _ref2.navigationAlignment,
      actions = _ref2.actions;
  var renderLeadingActionContainer = false;
  var renderTrailingActionContainer = false;

  if (navigationAlignment === NavigationAlignments.Leading) {
    renderLeadingActionContainer = hasNavigationItem;
  } else {
    renderTrailingActionContainer = hasNavigationItem;
  }

  if (hasBackButton) {
    renderLeadingActionContainer = true;
    renderTrailingActionContainer = hasNavigationItem;
  }

  if (actions && actions.length > 0) {
    renderTrailingActionContainer = true;
  }

  return {
    renderLeadingActionContainer: renderLeadingActionContainer,
    renderTrailingActionContainer: renderTrailingActionContainer
  };
};